module.exports = __webpack_public_path__ + "assets/img/banner4.34a257f0.png";